module.exports = __webpack_public_path__ + "59eb3601394dd87f30f82433fb39dd94.woff2";